import { makeStyles } from '@material-ui/core';

export const useReduxFormStyles = makeStyles((theme) => ({
  fieldLabel: {
    ...theme.typography.body1,
    color: '#A8A8A8',
    textTransform: 'uppercase'
  }
}));
